/**
 * Compact tutor/student card used in drag overlays and matching lists.
 */

import * as React from 'react';
import { GraduationCap, User } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { UserWithProfile } from '@/types/user.types';

/** Props for {@link MatchingDragPreview}. */
interface MatchingDragPreviewProps {
  user: UserWithProfile;
  type: 'tutor' | 'student';
  className?: string;
}

/** Ghost card shown while dragging a tutor or student in matching. */
export const MatchingDragPreview: React.FC<MatchingDragPreviewProps> = ({
  user,
  type,
  className,
}) => {
  const Icon = type === 'tutor' ? GraduationCap : User;
  const colorVar = '--color-1-nuance-1';

  return (
    <div className={cn('matching-user-card', className)}>
      <div className="flex items-center gap-2 flex-1">
        <div
          className="w-7 h-7 rounded-lg flex items-center justify-center border flex-shrink-0"
          style={{
            background: `color-mix(in srgb, var(${colorVar}) 15%, transparent)`,
            borderColor: `var(${colorVar})`,
          }}
        >
          <Icon className="w-4 h-4" style={{ color: `var(${colorVar})` }} />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-medium text-sm truncate">
            {type === 'student'
              ? user.displayName || user.email || 'Utilisateur'
              : `${user.firstName} ${user.lastName}`.trim() ||
                user.displayName ||
                user.email ||
                'Utilisateur'}
          </p>
        </div>
      </div>
    </div>
  );
};
